export default {
    Default: [ // 默认服装
        "GAssets/AsiaMale/head/BaseModelAmale_head.bundle",
        // "GAssets/AsiaMale/brow/brow000.bundle",
        // "GAssets/AsiaMale/cloth/lower_inner/shorts/shorts001.bundle",
        // "GAssets/AsiaMale/cloth/upper_inner/shirt/shirt001.bundle"
    ]
}